module.exports = __webpack_public_path__ + "static/1_1-885f4dd7f5e2a65df6d85b0cbdaa9a04.jpg";